<div class="smr-taptorefresh smr-empty-state" padding>
  <img src="./assets/images/oops-error.png" />
  <h4>Oops something went wrong.</h4>
  Please try again and contact us if the issue continues.
  <br /><br />
  <ion-button  fill="outline">
    <ion-icon  slot="start" name="refresh"></ion-icon>Tap to retry
  </ion-button>
</div>
